// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__J_9A_","label":"Category_label__1SndF","content":"Category_content__1Z904","header":"Category_header__UCioV","location":"Category_location__6frfD"};